import { device } from 'utils/device';
import {
	BEHAVIOUR_PHYSICS,
	PHYS_BOUNDARY,
	PHYS_RAIN,
	PHYS_Y_BOUNCE
} from 'app/views/home/webgl/particlesOptimised/core/ParticleCore';
import { OrganicLinesBasePhase } from 'app/views/home/webgl/particlesOptimised/departments/spaces/phases/OrganicLinesBasePhase';

/**
 * OrganicLinesQuickPhase — FORK of SpacesDepartment._organicLinesQuick.
 *
 * VISUAL: the short, violent variant — the swarm gathers on five centre
 * anchors, then at 2s the follow radius FLIPS NEGATIVE (the swarm snaps to
 * the far side of its anchors), collapses to 0 at 3s, and at 4.5s the five
 * anchors are dropped under physics gravity (no bounce) while the swarm
 * dims to 0.3 alpha; by 5s everything fades and shrinks to nothing.
 */
export class OrganicLinesQuickPhase extends OrganicLinesBasePhase {
	public readonly name = 'OrganicLinesQuick';

	public start(): void {
		const ctx = this._ctx;
		const core = ctx.core;
		const sizes = ctx.getFrameSizes();

		const followRadiusMax = 0.025;
		const mobileScaleBumpMax = 0.05;
		let r = 1 - Math.min(1, device.innerWidth / 1000);

		for (let n = this._totalTargets; n < ctx.activeCount; n++) {
			const lane = ctx.range.start + n;
			this.organicLineStartLane(lane);
			this.followLane(lane, this.rollFollowTarget(), followRadiusMax + r * mobileScaleBumpMax);
			core.blendAdd[lane] = 1;
		}

		for (let t = 0; t < this._totalTargets; t++) {
			this.organicTargetLane(ctx.range.start + t, sizes.xc, sizes.yc);
		}

		this._comboCounter.add(() => {
			r = 1 - Math.min(1, device.innerWidth / 1000);
			this.setSwarmRadius(-1 * followRadiusMax - r * mobileScaleBumpMax);
		}, 2000);

		this._comboCounter.add(() => {
			this.setSwarmRadius(0);
		}, 3000);

		//(the reference's 4000ms stage is an empty forEach — not ported.)

		this._comboCounter.add(() => {
			for (let n = this._totalTargets; n < ctx.activeCount; n++) {
				core.tAlpha[ctx.range.start + n] = 0.3;
			}

			for (let t = 0; t < this._totalTargets; t++) {
				const lane = ctx.range.start + t;
				//particlePhysics.active = true + drop(false, 0.02) — the gravity
				//argument is IGNORED by the reference (always 0.0002, bug kept):
				core.behaviourMask[lane] |= BEHAVIOUR_PHYSICS;
				core.vy[lane] = 0;
				core.vx[lane] = 0;
				//Boundary ON, bounce OFF: the reference's default
				//_processBoundaryTick parks these drops at the box floor
				//(vy = 0, gravity = 0) instead of letting them fall through
				//(stage-8 catch, same lane form as RainPhase):
				core.physFlags[lane] &= ~(PHYS_Y_BOUNCE | PHYS_RAIN);
				core.physFlags[lane] |= PHYS_BOUNDARY;
				core.gravity[lane] = 0.0002;
			}
		}, 4500);

		this._comboCounter.add(() => {
			for (let n = this._totalTargets; n < ctx.activeCount; n++) {
				core.tAlpha[ctx.range.start + n] = 0;
				core.tScale[ctx.range.start + n] = 0;
			}
		}, 5000);
	}
}
